var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import InputField from "@frameworks/web/components/generic/inputField";
import RadioButton from "@frameworks/web/components/generic/radioButton";
import SelectDropdown from "../../../../../../../shared-library/components/selectdropdown";
import { SaveMandColumn } from "./Constant";
import SaveMandate from "./SaveMandate";
import dimandateform from "../../../di/serviceLocator";
import di from "../../../di/serviceLocator";
export var meetingDetails = [
    {
        value: "Engagement",
        display: "Engagement",
    },
    {
        value: "Product Sales",
        display: "Product Sales",
    },
    {
        value: "Service",
        display: "Service",
    },
    {
        value: "Aquisition",
        display: "Aquisition",
    },
];
export var Aadharlink = [
    { value: "E", display: "Yes" },
    { value: "X", display: "No" },
];
var MandatePopup = function (props) {
    var _a = __read(useState(), 2), mandateType = _a[0], setMandateType = _a[1];
    var _b = __read(useState(), 2), bankList = _b[0], setBankList = _b[1];
    var _c = __read(useState(), 2), accountNo = _c[0], setaccountNo = _c[1];
    var _d = __read(useState(), 2), selectedBank = _d[0], setSelectedBank = _d[1];
    var _e = __read(useState(), 2), amount = _e[0], setAmount = _e[1];
    var _f = __read(useState(), 2), mandateDetails = _f[0], setMandateDetails = _f[1];
    var _g = __read(useState(), 2), error = _g[0], setError = _g[1];
    var _h = __read(useState([]), 2), refIdTableData = _h[0], setrefIdTableData = _h[1];
    useEffect(function () {
        di.clients
            .getBankDetailsMandateForms({ Accode: props.AccCode })
            .then(function (bankDetails) {
            if ((bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.length) > 0) {
                var list = bankDetails.map(function (bank) {
                    return {
                        value: bank.bankName,
                        display: bank.bankName,
                    };
                });
                setBankList(list);
            }
        })
            .catch(function (err) {
            console.log(err);
        });
        di.clients
            .getMandateDetails({
            Accode: props.AccCode,
            page: 1,
            pageSize: 50,
        })
            .then(function (mandate) {
            if ((mandate === null || mandate === void 0 ? void 0 : mandate.length) > 0) {
                setMandateDetails(mandate);
            }
        })
            .catch(function (err) { return console.log(err); });
        getRefIdTableDetails();
    }, []);
    var onChangeBank = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var validate, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setaccountNo(e.target.value);
                    setSelectedBank(undefined);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!(mandateType === "E")) return [3 /*break*/, 3];
                    return [4 /*yield*/, di.clients.getValidateBank({
                            accode: props.AccCode,
                            BankName: e.target.value,
                        })];
                case 2:
                    validate = _a.sent();
                    if (validate) {
                        alert("This bank is not emandate qualified bank. Please click on No radio button and proceeds with physical mandate");
                        return [2 /*return*/];
                    }
                    _a.label = 3;
                case 3:
                    di.clients
                        .getBankBranchDetailsMandateForms({
                        Accode: props.AccCode,
                        BankName: e.target.value,
                    })
                        .then(function (branchDetails) {
                        if (branchDetails)
                            setSelectedBank(branchDetails);
                    })
                        .catch(function (err) { return console.log(err); });
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    di.clients
                        .getBankBranchDetailsMandateForms({
                        Accode: props.AccCode,
                        BankName: e.target.value,
                    })
                        .then(function (branchDetails) {
                        if (branchDetails)
                            setSelectedBank(branchDetails);
                    })
                        .catch(function (err) { return console.log(err); });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (e) {
        e.preventDefault();
        if (mandateType == "E" && parseFloat(amount) > 100000) {
            alert("Max Amount limit 1,00,000/");
            return false;
        }
        di.clients
            .requestMandate({
            clientCode: props.AccCode,
            mandateMode: "MFI",
            amount: amount,
            bankName: selectedBank.bankName,
            branch: selectedBank.branch,
            status: "",
            requestedBy: "SYSTEM",
            mandateType: mandateType,
            accountNumber: selectedBank.bankAccNO,
            ifscCode: selectedBank.ifscCode,
            remarks: "",
            userId: props.userID,
        })
            .then(function (save) { return alert(save.data); })
            .catch(function (err) { return console.log(err); });
    };
    var getRefIdTableDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dimandateform.clients
                        .getRefIdData({
                        Accode: props.AccCode,
                    })
                        .then(function (RefIdResult) {
                        if (RefIdResult) {
                            setrefIdTableData(RefIdResult.result);
                        }
                    })
                        .catch(function (error) { })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "px-0 mx-0 dpledger-block mandate-details-popup-block" },
        React.createElement(Row, { className: "px-0 mx-0" },
            React.createElement(Col, { className: "px-0 HeadRow" },
                React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                    React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                            props.setledgershow(false);
                        } }),
                    "Mandate Details-",
                    React.createElement("span", { className: "EncodeSans_20_700" },
                        props.dpname,
                        ", Accode:",
                        props.AccCode)))),
        React.createElement("div", { className: "mandate-radiobtn-block" },
            React.createElement(Col, { className: "mandate-radiobtn-tile" },
                React.createElement("span", { className: "DMSanN_14_400 txt_primaryGrey" }, "Client's Bank Linked With Aadhar:"),
                React.createElement("div", { className: "mandate-radio-btns" }, Aadharlink.map(function (item, count) {
                    return (React.createElement(RadioButton, { name: "adharlink", list: item, onChange: function (e) {
                            setMandateType(e.target.value);
                            setaccountNo(undefined);
                            setSelectedBank(undefined);
                        }, selected: mandateType, key: count }));
                })),
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "E-mandate Process", className: "e-mandate" }))),
        mandateType && (React.createElement(React.Fragment, null,
            React.createElement("form", { onSubmit: onSubmit },
                React.createElement(Row, { className: "bankdetails-block mx-0" },
                    React.createElement(Col, { className: "px-0", lg: 3 },
                        React.createElement("div", { className: "px-0 flexJustifySpaceBetween mbt-5" },
                            React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Bank Name")),
                        React.createElement(Col, { className: "px-0 leadpage-selectdropdown" },
                            React.createElement(SelectDropdown, { className: "basic-multi-select DMSanN_16_400", placeholderClassName: "holder leadselect-holder DMSanN_16_400", placeholder: "Select Bank", id: "md_prodfeedback", name: "md_prodfeedback", selected: true, defaultValue: accountNo, dropdownOptions: bankList, onChangeEvent: onChangeBank, downarrow: "edel-icon-arrow-down", required: true }))),
                    React.createElement(Col, { className: "px-0 input-error", lg: 3 },
                        React.createElement("div", { className: "px-0 mbt-5" },
                            React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Amount")),
                        React.createElement(Col, { className: "px-0 DMSanN_16_400" },
                            React.createElement(InputField, { placeholder: "Select", id: "md_pipeline", name: "md_pipeline", type: "number", onChange: function (value) { return setAmount(value); }, required: true, autoComplete: "off", placeholderClassName: "DMSanN_16_400" }))),
                    React.createElement(Col, { lg: 2, className: "px-0" },
                        React.createElement(EdButton, { type: "submit", btnTyp: "midnight-blue", value: "Save" })))),
            React.createElement("div", { className: "branchname-block" },
                React.createElement("div", { className: "branchname-tile" },
                    React.createElement("div", { className: "DMSansMedium_12_500 txt_secondary-gray" }, "Branch:"),
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.branch)),
                React.createElement("div", { className: "branchname-tile" },
                    React.createElement("div", { className: "DMSansMedium_12_500 txt_secondary-gray" }, "IFSC Code:"),
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.ifscCode)),
                React.createElement("div", { className: "branchname-tile" },
                    React.createElement("div", { className: "DMSansMedium_12_500 txt_secondary-gray" }, "MICR Code:"),
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.micR_NO))),
            React.createElement(Row, { className: "savemandate-table-block  mx-0" },
                (mandateDetails === null || mandateDetails === void 0 ? void 0 : mandateDetails.length) > 0 && (React.createElement(SaveMandate, { mandateDetails: mandateDetails })),
                React.createElement(Row, { className: "savemandate-table-tile1 mx-0 px-0" },
                    React.createElement(GenericTable, { columns: SaveMandColumn, data: refIdTableData, parentClassName: "salestableParentClass table-responsive commonscroll-new", tableClassName: "salestableclass" })))))));
};
export default MandatePopup;
